import { render, staticRenderFns } from "./Stadiums.vue?vue&type=template&id=5b31882b"
import script from "./Stadiums.vue?vue&type=script&lang=js"
export * from "./Stadiums.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports